import { render, staticRenderFns } from "./u-confirm.vue?vue&type=template&id=423fbb7d&scoped=true&"
import script from "./u-confirm.vue?vue&type=script&lang=js&"
export * from "./u-confirm.vue?vue&type=script&lang=js&"
import style0 from "./u-confirm.vue?vue&type=style&index=0&id=423fbb7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423fbb7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('423fbb7d')) {
      api.createRecord('423fbb7d', component.options)
    } else {
      api.reload('423fbb7d', component.options)
    }
    module.hot.accept("./u-confirm.vue?vue&type=template&id=423fbb7d&scoped=true&", function () {
      api.rerender('423fbb7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/documents/u-confirm.vue"
export default component.exports